import axios from '@axios'

export default {
  namespaced: true,
  state:()=>({
    root:null,
    loadings:0,
    readOnly:false,
    id:null,
    name:null,
    device_id:null,
    deviceOptions:[],
    camp_id:null,
    campOptions:[],
    camp_leave:null,
    camp_back:null,
    areaOptions:[],
    work_days:[
      'Saturday',
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday'
  ],
    areas:[],
    errors:[]
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    startLoadingState(state){
      state.loadings += 1;
    },
    stopLoadingState(state){
      state.loadings -= 1;
    },
    activateReadOnlyMode(state){
      state.readOnly = true
    },
    updateId(state, payload){
      state.id = payload.value
    },
    updateName(state, payload){
      state.name = payload.value
    },
    updateDeviceId(state, payload){
      state.device_id = payload.value
    },
    updateDeviceOptions(state, payload){
      state.deviceOptions = payload
    },
    updateCampId(state, payload){
      state.camp_id = payload.value
    },
    updateCampOptions(state, payload){
      state.campOptions = payload
    },
    updateCampLeave(state, payload){
      state.camp_leave = payload.value
    },
    updateCampBack(state, payload){
      state.camp_back = payload.value
    },
    updateWorkDays(state, payload){
      state.work_days = payload.value
    },
    updateAreaOptions(state, payload){
      state.areaOptions = payload
    },
    addArea(state, payload){
      
      let values = {
        geofence_id:null
      }

      if(payload != undefined){
        values = payload.values
      }

      state.areas.push({
        id: state.areas[ state.areas.length - 1 ] != undefined ? state.areas[ state.areas.length - 1 ].id + 1 : 0,
        ...values
      })

    },
    updateArea(state, payload){
      state.areas = state.areas.map((area)=> {
        if(area.id == payload.id){
          area[payload.key] = payload.value
        }
        return area
      })
    },
    removeArea(state, payload){
      state.areas = state.areas.filter((area)=> {
        if(area.id == payload.id){
          return false
        }
        return true
      })
    },
    removeAllAreas(state){
      state.areas = []
    },
    updateErrors(state, payload){
      state.errors = payload
    },
  },
  actions: {
    create({ getters, commit }){
      commit('startLoadingState')
      axios.post('plans', { 
        type:'containerArea',
        ...(getters.fields.includes('name') && {name: getters.name}),
        ...(getters.fields.includes('device_id') && {device_id: getters.device_id}),
        ...(getters.fields.includes('camp_id') && {camp_id: getters.camp_id}),
        ...(getters.fields.includes('camp_leave') && {camp_leave: getters.camp_leave}),
        ...(getters.fields.includes('camp_back') && {camp_back: getters.camp_back}),
        ...(getters.fields.includes('work_days') && {work_days: getters.work_days}),
        ...(getters.fields.includes('areas') && {areas: getters.areas}),
      })
      .then(response => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_CREATE_SUCCESS_MESSAGE'), {
            variant: 'success',
        })
        getters.root.$router.push({ name: 'plans.containerArea.edit', params: { id: response.data.plan.id } })
      })
      .catch( reason => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_CREATE_FAILURE_MESSAGE'), {
          variant: 'danger'
        })
        commit('updateErrors' , reason.response.data.errors)
      })
      .finally(() => commit('stopLoadingState'))
    },
    update({ getters, commit, dispatch }){
      commit('startLoadingState')
      axios.put(`plans/${getters.id}`, {
        type:'containerArea',
        id:getters.id,
        ...(getters.fields.includes('name') && {name: getters.name}),
        ...(getters.fields.includes('device_id') && {device_id: getters.device_id}),
        ...(getters.fields.includes('camp_id') && {camp_id: getters.camp_id}),
        ...(getters.fields.includes('camp_leave') && {camp_leave: getters.camp_leave}),
        ...(getters.fields.includes('camp_back') && {camp_back: getters.camp_back}),
        ...(getters.fields.includes('work_days') && {work_days: getters.work_days}),
        ...(getters.fields.includes('areas') && {areas: getters.areas}),
      })
      .then(response => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_UPDATE_SUCCESS_MESSAGE'), {
            variant: 'success',
        })
        dispatch('load', {id:getters.id})
      })
      .catch( reason => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_UPDATE_FAILURE_MESSAGE'), {
          variant: 'danger'
        })
        commit('updateErrors' , reason.response.data.errors)
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchOptions({ dispatch }){
      dispatch('fetchDeviceOptions')
      dispatch('fetchCampOptions')
      dispatch('fetchAreaOptions')
    },
    fetchDeviceOptions({ commit, rootGetters }){
      commit('startLoadingState')
      axios.get('userGetLinked', { params:{
        type: 'device',
        category:'COMPACTOR',
        user:rootGetters['auth/user']['id']
      }})
      .then(r => {
          commit('updateDeviceOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_DEVICE_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchCampOptions({ commit, getters, rootGetters }){
      commit('startLoadingState')
      axios.get('userGetLinked', { params:{
        type: 'geofence',
        category:'CAMP_AREA',
        linkedWithDevice:getters.device_id,
        user:rootGetters['auth/user']['id']
      }})
      .then(r => {
          commit('updateCampOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_CAMP_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchAreaOptions({ commit, getters, rootGetters }){
      commit('startLoadingState')
      axios.get('userGetLinked', { params:{
        type: 'geofence',
        category:'CONTAINER_AREA',
        linkedWithDevice:getters.device_id,
        user:rootGetters['auth/user']['id']
      }})
      .then(r => {
          commit('updateAreaOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_AREA_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    load({ commit, getters }, payload ){
      commit('startLoadingState')
      axios.get(`plans/${payload.id}`)
      .then(response => {

            commit('updateId', {value:response.data.plan.id})
            commit('updateName', {value:response.data.plan.name})
            commit('updateDeviceId', {value:response.data.plan.device_id})
            commit('updateCampId', {value:response.data.plan.camp_id})
            commit('updateCampLeave', {value:response.data.plan.camp_leave})
            commit('updateCampBack', {value:response.data.plan.camp_back})
            commit('updateWorkDays', {value:response.data.plan.data.work_days})

            commit('removeAllAreas')

            response.data.plan.data.areas.forEach((geofence_id)=> {
              commit('addArea', {values:{geofence_id}})
            })

            commit('stopLoadingState')
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('PLANS_LOAD_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
    },
    loadFromRoute({ getters, dispatch }){
      dispatch('load', {id:getters.root.$router.currentRoute.params.id})
    },
    importAreasFromKML({ commit, getters }, payload ){
      commit('startLoadingState')
      payload.file.arrayBuffer().then(((data)=> {
        (new DOMParser()).parseFromString(new TextDecoder().decode(data), 'text/xml')
        .getElementsByTagName('Placemark')
        .forEach(placemark => {
          for(let node of placemark.children) {

            if(node.nodeName == 'name'){

              let option = getters.areaOptions.find((option)=> option.name == node.textContent && !getters.areas.includes(option.geofence_id))

              if(option != undefined){
                  commit('addArea', {values:{geofence_id:option.geofence_id}})
              }
              
              break
            }
          }
        });
        commit('stopLoadingState')
      }))
    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loadings > 0
    },
    isReadOnly(state){
      return state.readOnly
    },
    fields(state){
      return [
        'name',
        'device_id',
        'camp_id',
        'camp_leave',
        'camp_back',
        'work_days',
        'areas'
      ]
    },
    errors(state){
      return state.errors
    },
    id(state){
      return state.id
    },
    name(state){
      return state.name
    },
    device_id(state){
      return state.device_id
    },
    deviceOptions(state){
      return state.deviceOptions
    },
    camp_id(state){
      return state.camp_id
    },
    campOptions(state){
      return state.campOptions
    },
    camp_leave(state){
      return state.camp_leave
    },
    camp_back(state){
      return state.camp_back
    },
    work_days(state){
      return state.work_days
    },
    workDaysOptions(state){
      return [
          'Saturday',
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday'
      ].map((option)=> {
        return {
          text:state.root.$t(option),
          value:option
        }
      })
    },
    campTimeConfig(){
      return {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i:S",
      }
    },
    areaOptions(state){
      return state.areaOptions
    },
    areas(state){
      return state.areas.map((area)=> area.geofence_id)
    },
    areasList(state){
      return state.areas
    },
    area:(state) => (id, key) => {
      return state.areas.find(area => area.id === id)[key]
    }

  }
}
